export class AppDatatableChangeEvent {
    
    public type: string;
    public option: any;
    public data: any;

    constructor(type: string, data: any = {}, option: any = undefined) {
        this.type = type;
        this.data = data;
        this.option = option;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/datatable/models/change-event.model.ts